import { StringMap } from '@/shared/utils/map'
import { FormAttributeDefinition } from '@/shared/forms/form-attribute-definition'
import { getProperty } from '@/shared/forms/functions/get-property'

export function defaultDeserializer(
  input: StringMap<any>,
  attribute: FormAttributeDefinition
): any {
  return getProperty(input, attribute.selector)
}
